import { api } from "./api";

// F4-C · Otorgamiento administrativo de licencia de Programa Especializado.
// origen="ADMINISTRADOR" y admin_id los fija el backend. Reutiliza el endpoint F1.
export async function otorgarLicenciaAdmin(payload) {
  const { data } = await api.post("/software/admin/licencias/otorgar", payload);
  return data; // { ok, licencia: { fecha_activacion, fecha_vencimiento, ... } }
}

// Edita precios vigentes de un programa (céntimos enteros). NO reescribe licencias históricas.
export async function actualizarPreciosPrograma(pid, precios) {
  const { data } = await api.put(`/software/admin/programas/${pid}/precios`, precios);
  return data; // { ok, precios, programa }
}

// Selector Admin: programas licenciables SIN filtro de estado (incluye En preparación/draft).
export async function fetchProgramasLicenciablesAdmin() {
  const { data } = await api.get("/software/admin/programas/licenciables");
  return data;
}

// ---------- PASO 5B · Licencia actual + revocación + dispositivos (Admin) ----------
export async function fetchLicenciaActualAdmin(userId, slug) {
  const { data } = await api.get("/software/admin/licencia", { params: { user_id: userId, programa_slug: slug } });
  return data;
}

export async function revocarLicenciaAdmin(userId, slug, motivo) {
  const { data } = await api.post("/software/admin/licencias/revocar", { user_id: userId, programa_slug: slug, motivo: motivo || null });
  return data;
}

export async function fetchDispositivosAdmin(userId, slug) {
  const { data } = await api.get("/software/admin/dispositivos", { params: { user_id: userId, programa_slug: slug } });
  return data; // array de dispositivos
}

export async function desvincularDispositivoAdmin(deviceId) {
  const { data } = await api.post(`/software/admin/dispositivos/${deviceId}/revocar`);
  return data;
}

export async function reactivarDispositivoAdmin(deviceId) {
  const { data } = await api.post(`/software/admin/dispositivos/${deviceId}/reactivar`);
  return data;
}

export async function fetchLicenciasHistorialAdmin() {
  const { data } = await api.get("/software/admin/licencias/historial");
  return data; // { items, total }
}
